// import Container from "react-bootstrap/Container";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
import React, { Fragment, useEffect, useState } from "react";
// import Link from "react-router-dom/Link.js";
import HttpBaseUrl from "./../../httpservice/common.http.js";
import { getCateListData, getLatestPost, adRenderLogic } from "../../context/apiState.js";
import axios from "axios";
import HeaderMenu from "../header/header.js";
import Footer from "../footer-new/footer-new.js";
import styles from "../home-new/HomeMain.module.css";
import "../home-new/home-new.css";
import { Helmet } from "react-helmet";
import CategoryLazyLoadImage from "../LazyImageLoad/LOadImages.jsx";
const Link = require("react-router-dom").Link;

let saveAdtagsArrays = [];

const HomeMain = React.memo(() => {
    // state for Trending Articles
    const [trendingPosts, setTrendingPosts] = useState([]);
    const [allCateData, setAllCateData] = useState();
    const [allLatestData, setAllLatestData] = useState();
    const [showFooter, setShowFooter] = useState(false);
    const [isScroll, setIsScroll] = useState(false);

    let isAlreadyRun = false;
    let article_utm_source = localStorage.getItem('utm_source');
    // find utm source
    let Paramvalue = window.location.href.split('/');
    let cd = Paramvalue[3].split('&');
    let utm_source = undefined;
    let article_type = undefined;

    if (cd.length > 0 && cd[0] != '') {
        utm_source = cd[0]?.split('=')[1];
        article_type = cd[1]?.split('=')[1];
    }
    if (utm_source == undefined) {
        utm_source = article_utm_source ? article_utm_source : "Seekapeek";
    }

    if (article_type == undefined) {
        article_type = 1;
    }

    let lang = localStorage.getItem("language") ? localStorage.getItem("language") : 1;
    if (lang) {
        article_type = lang;
    }

    const makeSoltByAdType = (locationDivId, slotDivId, token) => {
        let adType = 0;
        var trendingDOM = document.getElementById(locationDivId); // location div id where solt div appended

        if (slotDivId) {
            let wrapperDiv = document.createElement('div'),
                bgWrapperDiv = document.createElement('div'),
                bgIn = document.createElement('div'),
                trendingAds = document.createElement('div');

            wrapperDiv.className = 'wrapper_in';
            wrapperDiv.id = `wrapper_in_${slotDivId}`;
            wrapperDiv.style = "position: relative; width:490px; height: 1px; margin:0 auto";
            bgWrapperDiv.className = 'bg-wrapper_in';
            bgIn.className = 'bg_in';
            trendingAds.id = slotDivId; // sloat div id where ad render
            trendingAds.className = 'adsCent';

            bgIn.appendChild(trendingAds);
            bgWrapperDiv.appendChild(bgIn);
            wrapperDiv.appendChild(bgWrapperDiv);

            if (token) {
                if (token.includes("@@}_@")) {
                    adType = token.split("@@}_@")[1].split("@_")[0];
                    if (adType) {
                        adType = Number(adType);
                        // If ad token for interscroller then append interscroller div
                        if (adType == 1) {
                            trendingDOM.append(wrapperDiv);
                            return true;
                        }
                    }
                } else {
                    if (adType == 0) {
                        trendingDOM.append(trendingAds);
                        return true;
                    }
                }
            }
        }
        return false;
    }

    const headerAds = async (adSlots) => {
        let adTagResponse = await getapiData(getIdFromToken(adSlots.adSlots.heaAd));
        if (adTagResponse) {
            adRenderLogic(adTagResponse, "homeHeaderAd", `div-gpt-ad-1690980415735-001`);
        }
    }

    const stickyAds = async (adSlots) => {
        let adTagResponse = await getapiData(getIdFromToken(adSlots.adSlots.stiAd));
        if (adTagResponse) {
            adRenderLogic(adTagResponse, "stickyAds", `div-gpt-ad-1690980415735-002`);
        }
    }

    const trendingAds = async (adSlots) => {
        let token = adSlots.adSlots.feedAd;
        // Make ad div by ad type 
        const isSloatAppended = makeSoltByAdType("trendingAdsLocation", "trendingAds", token);
        if (isSloatAppended) {
            let adTagResponse = await getapiData(getIdFromToken(token));
            if (adTagResponse) {
                adRenderLogic(adTagResponse, "trendingAds", `div-gpt-ad-1690980415735-003`);
            }
        }
    }
    const latestAds = async (adSlots) => {
        let token = adSlots.adSlots.feedAd;
        // Make ad div by ad type 
        const isSloatAppended = makeSoltByAdType("latestAdsAdsLocation", "latestAds", token);

        if (isSloatAppended) {
            let adTagResponse = await getapiData(getIdFromToken(token));
            if (adTagResponse) {
                adRenderLogic(adTagResponse, "latestAds", `div-gpt-ad-1690980415735-004`);
            }
        }
    }

    const innerArticleAfterLoadMore = async (adSlots, renderLimit) => {
        for (let i = 0; i < Number(renderLimit); i++) {
            let token = adSlots.adSlots.homeCat[i].adToken;
            // Make ad div by ad type 
            const isSloatAppended = makeSoltByAdType(`${i}_articlefeedLocation`, `${i}_articlefeed`, token);
            if (isSloatAppended) {
                let adTagResponse = await getapiData(getIdFromToken(token));
                if (adTagResponse) {
                    adRenderLogic(adTagResponse, `${i}_articlefeed`, `div-gpt-ad-1690980415735-${i}`);
                }
            }
        }
    }

    async function latestAdAfterTwoArticles(adSlots) {

        let token = adSlots.adSlots.feedAd;
        // Make ad div by ad type 
        const isSloatAppended = makeSoltByAdType("latestAfterTwoLocation", "latestAfterTwo", token);

        if (isSloatAppended) {
            let adTagResponse = await getapiData(getIdFromToken(token));
            if (adTagResponse) {
                adRenderLogic(adTagResponse, "latestAfterTwo", `div-gpt-ad-latestAfterTwo`);
            }
        }
    }

    const getSlotsFromTag = (head_tag) => {
        let tagSlots = null;
        if (head_tag) {
            let headTagValue = head_tag.split("[[");
            tagSlots = headTagValue[1].split("]]")[0];
        }
        return JSON.parse(`[[${tagSlots}]]`);
    }


    // Trending Api
    const getTrendingPost = () => {
        const trendingPostApi = `${HttpBaseUrl.getBaseUrl()}/articles/trending/${lang ? lang : 1}`;
        fetch(trendingPostApi, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            }
        }).then(trendingPostData => {
            return trendingPostData.json();
        }).then(trendingPostRes => {
            const randomArray = (shuffleArray) => {
                for (let i = shuffleArray.length - 1; i > 0; i--) {
                    let j = Math.floor(Math.random() * (i + 1))
                    let temp = shuffleArray[i]
                    shuffleArray[i] = shuffleArray[j]
                    shuffleArray[j] = temp
                }
                return shuffleArray;
            }
            randomArray(trendingPostRes);
            setTrendingPosts(trendingPostRes);
        })
    }

    const getIdFromToken = (adToken) => {
        if (adToken) {
            let idFromToken = adToken?.split(".")[1]?.split("@@")[0];
            return idFromToken;
        }
    }

    async function callAllCategory() {
        let allCategoryData = await getCateListData();
        if (allCategoryData) {
            setAllCateData(allCategoryData);
            console.log(setAllCateData);
            // console.log(allCateData.firstCategory);           
        }
    }
    async function callLatestCategory() {
        let allLatestData = await getLatestPost();
        if (getLatestPost) {
            setAllLatestData(allLatestData);
        }
    }

    function manageScroll() {
        window.scrollBy(0, 60);
        setTimeout(() => {
            window.scrollBy(0, -60);
        }, 100)
    }

    function scrollToViewFeed() {
        // if (trendingPosts.length  0) {
        //     setIsScroll(true);
        //     runAfterScroll();
        // }

        window.addEventListener("scroll", function (event) {
            var top = this.scrollY,
                left = this.scrollX;
            if (top > 50 && !isAlreadyRun) {
                isAlreadyRun = true;
                setIsScroll(true);
                runAfterScroll();
            }
        }, false);
    }

    async function runAfterScroll() {
        let allCateData = await getCateListData();
        latestAds(allCateData);
        innerArticleAfterLoadMore(allCateData, 5);
        latestAdAfterTwoArticles(allCateData);
    }

    async function getapiData(adTagId) {
        if (!adTagId) {
            return null;
        }

        let result = null;
        let isDuplicateRequest = false;

        if (saveAdtagsArrays.length > 0) {
            for (let i = 0; i < saveAdtagsArrays.length; i++) {
                const saveAdTag = saveAdtagsArrays[i];
                if (saveAdTag.tagId == adTagId) {
                    isDuplicateRequest = true;
                    result = saveAdTag;
                    break;
                }
            }
        }

        if (!isDuplicateRequest) {
            let url = `${HttpBaseUrl.getBaseUrl()}/ad-tags/${adTagId}/${utm_source}`;
            let response = await axios.get(url);
            result = response.data;
            if (result) {
                result["tagId"] = adTagId; // tagId
            } else {
                result = {
                    head_tag: "",
                    body_tag: "",
                    tagId: adTagId,
                };
            }
            // save adTag in state if is fresh ad request
            // let savedAdtagsInfo = [...saveAdtags];
            saveAdtagsArrays.push(result);
            // setSaveAdtags(saveAdtagsArrays);
        }
        return result;
    }




    useEffect(() => {
        // manageInitialScroll();
        getTrendingPost();
        callAllCategory();
        callLatestCategory();
        // latestAdAfterTwoArticles();

    }, [])

    useEffect(() => {
        if (allCateData) {
            headerAds(allCateData);
            trendingAds(allCateData);
            // latestAds(allCateData);
            // innerArticleAfterLoadMore(allCateData, 5);
            stickyAds(allCateData);
        }
    }, [allCateData])

    useEffect(() => {
        scrollToViewFeed();
    }, [])


    useEffect(() => {

        const footertimer = setTimeout(() => {
            setShowFooter(true);
        }, 2000);

        return () => clearTimeout(footertimer);
    }, []);
    // console.log(allCateData ? allCateData.firstCategory.list.length : "");
    return (
        <div className="bodyWidth">
            <HeaderMenu allCateData={allCateData} headerConfig={{
                utm_source: utm_source,
                article_type: article_type
            }} />

            <Helmet>
                <meta charSet="utf-8" />
                <meta name="title" content={allCateData ? allCateData?.adSlots.metaTitle : ""} />
                <meta name="description" content={allCateData ? allCateData.adSlots.metaDescription : ""} />
                <meta name="keywords" content={allCateData ? allCateData.adSlots.metaKeyword : ""} />
            </Helmet>

            {/* header ad */}

            <div id="homeHeaderAd" className={styles.homeHeaderAds}>
                {/* Header Ad Here */}
            </div>

            {/* Trdening Articles */}
            <section className={styles.trendingPosts + " mt-lg-3 mt-md-3 mt-sm-0 mt-xs-0"} id="trendingId">
                <div className="container">
                    <div className="row" style={{ margin: "0" }}>
                        <div className="col-md-12 mt-lg-3 mt-md-3 mb-md-3 mb-lg-3 mb-sm-3 mb-3 mt-3">
                            <h2 className={styles.categoryTitle}>
                                {lang == 2 ? process.env.REACT_APP_TRENDING_HIN : process.env.REACT_APP_TRENDING_ENG}
                            </h2>
                        </div>
                        {
                            trendingPosts.length > 4 ?
                                <Fragment>
                                    <div className="col-md-12">
                                        {
                                            trendingPosts?.length > 4 ?

                                                <Link to={`/categories/byte${trendingPosts[0].id}/${trendingPosts[0].slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank" style={{ "textDecoration": "none" }}>
                                                    <div className={`${styles.trendingLeft} ${styles.hoverDivImg1_1}`}>
                                                        <div className={styles.hoverDivImg1_1}>
                                                            {/* <img loading="lazy" src={trendingPosts[0].iImg=?trendingPosts[0].iImg:'https://images.ctfassets.net/hrltx12pl8hq/3Z1N8LpxtXNQhBD5EnIg8X/975e2497dc598bb64fde390592ae1133/spring-images-min.jpg'} className={`${styles.postBigImg} ${styles.height430} ${styles.hoverImg}`} alt={trendingPosts[0]?.title?.length > 15 ? `${trendingPosts[0].title.slice(0, 15)}...` : trendingPosts[0].title} /> */}
                                                            <CategoryLazyLoadImage dataSrc={trendingPosts[0].iImg} width="100%" height="100%" className={`${styles.postBigImg} ${styles.height430} ${styles.hoverImg}`} alt={trendingPosts[0]?.title?.length > 15 ? `${trendingPosts[0].title.slice(0, 15)}...` : trendingPosts[0].title} />

                                                        </div>
                                                        <div className={styles.trendingLeftTxt}>
                                                            <span className={`${styles.categoryHome} ${styles.catBg2}`}>{trendingPosts[0].cName[0]}</span>
                                                            <h3 className={`${styles.postTitleBig} ${styles.fontSize26} ${styles.postTitleColor}`}>{trendingPosts[0].title.length > 65 ? `${trendingPosts[0].title.slice(0, 65)}...` : trendingPosts[0].title}</h3>
                                                        </div>
                                                    </div>
                                                </Link>
                                                : null
                                        }
                                    </div>
                                    <div className="col-md-12">
                                        {
                                            trendingPosts?.length > 4 ?
                                                trendingPosts?.map((trendingData, trendingDataIndex) => {
                                                    if (trendingDataIndex >= 1 && trendingDataIndex < 5) {
                                                        return (
                                                            <Fragment key={trendingDataIndex}>
                                                                <Link to={`/categories/byte${trendingData.id}/${trendingData.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">

                                                                    <div className={`${styles.trendingRight} ${styles.hoverDiv}`}>
                                                                        <div className={styles.hoverDivImg1}>
                                                                            {/* <img loading="lazy" src={trendingData.iImg} className={`${styles.trendingRightImg} ${styles.hoverImg}`} alt={trendingData?.title?.length > 15 ? `${trendingData?.title?.slice(0, 15)}...` : trendingData?.title} /> */}
                                                                            <CategoryLazyLoadImage dataSrc={trendingData.iImg} className={`${styles.trendingRightImg} ${styles.hoverImg}`} alt={trendingData?.title?.length > 15 ? `${trendingData?.title?.slice(0, 15)}...` : trendingData?.title} />

                                                                        </div>
                                                                        <div className={styles.trendingRightTxt}>
                                                                            <span className={`${styles.categoryHome} ${styles.catBg2}`}>{trendingData.cName[0]}</span>
                                                                            <h3 className={`${styles.postTitleSmall} ${styles.fontSize16} ${styles.hoverFont}`}>{trendingData.title.length > 30 ? `${trendingData.title.slice(0, 30)}...` : trendingData.title}</h3>
                                                                            <p className={styles.gridPostPara}>{trendingData.desc.length > 88 ? `${trendingData.desc.slice(0, 88)}...` : trendingData.desc}</p>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            </Fragment>
                                                        )
                                                    }
                                                })
                                                : null
                                        }
                                    </div>
                                </Fragment>
                                : <>
                                    {manageScroll()}
                                    <span></span>
                                </>
                        }
                    </div>
                </div>
                <center>
                    <div id="trendingAdsLocation"></div>
                </center>
            </section>

            {
                isScroll ?
                    <>
                        {/* Latest Category */}
                        <section className={styles.latestPosts + " mt-sm-3 mt-md-3 mt-lg-3 mt-3 "}>
                            <div className="container">
                                {/* <Row> */}
                                <div className="row" style={{margin:"0"}}>
                                <div className="col-md-12 mt-3 mb-3 mx-3 mx-lg-0 mx-xlg-0">
                                    <h2 className={styles.categoryTitle}>
                                        {lang == 2 ? process.env.REACT_APP_LATEST_HIN : process.env.REACT_APP_LATEST_ENG}
                                    </h2>
                                </div>
                                </div>
                                <div className={styles.rowMargin + " row "}>
                                    {
                                        allLatestData ?
                                            allLatestData.content?.length > 4 ?
                                                allLatestData.content?.map((latestPostMap, latestPostIndex) => {
                                                    if (latestPostIndex >= 0 && latestPostIndex < 2) {
                                                        return (
                                                            <Fragment key={latestPostIndex}>
                                                                <div className="col-sm-6">
                                                                    <Link to={`/categories/byte${latestPostMap.id}/${latestPostMap.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">
                                                                        <div className={`${styles.gridPosts} ${styles.hoverDiv}`}>
                                                                            <div className={`${styles.hoverDivImg2} ${styles.width100}`}>
                                                                                {/* <img loading="lazy" fetchPriority = "high" src={latestPostMap.iImg} className={`${styles.height250} ${styles.hoverImg} ${styles.imgMaxWidth}`} alt={latestPostMap.title.length > 15 ? `${latestPostMap?.title?.slice(0, 15)}...` : latestPostMap?.title} /> */}
                                                                                <CategoryLazyLoadImage dataSrc={latestPostMap.iImg} className={`${styles.height250} ${styles.hoverImg} ${styles.imgMaxWidth}`} alt={latestPostMap.title.length > 15 ? `${latestPostMap?.title?.slice(0, 15)}...` : latestPostMap?.title} />

                                                                            </div>
                                                                            <div className={styles.gridPostsTxt}>
                                                                                <h3 className={`${styles.gridPostTitle} ${styles.padding12} ${styles.fontSize18} ${styles.hoverFont} py-1`}>{latestPostMap.title.length > 25 ? `${latestPostMap.title.slice(0, 25)}...` : latestPostMap.title}</h3>
                                                                                <p className={styles.gridPostPara}>{latestPostMap.desc.length > 90 ? `${latestPostMap.desc.slice(0, 90)}...` : latestPostMap.desc}</p>
                                                                                <span className={`${styles.categoryHome} ${styles.catBg4} ${styles.gridPostsCate}`}>{latestPostMap.cName[0]}</span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            </Fragment>
                                                        )
                                                    }

                                                })
                                                : null
                                            : null
                                    }
                                    <center>
                                        <div id='latestAfterTwoLocation' className="latestAfTwo"></div>
                                    </center>
                                    {
                                        allLatestData ?
                                            allLatestData.content?.length > 4 ?
                                                allLatestData.content?.map((latestPostMap, latestPostIndex) => {
                                                    if (latestPostIndex >= 2 && latestPostIndex < 6) {
                                                        return (
                                                            <Fragment key={latestPostIndex}>
                                                                <div className="col-sm-6">
                                                                    <Link to={`/categories/byte${latestPostMap.id}/${latestPostMap.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">
                                                                        <div className={`${styles.gridPosts} ${styles.hoverDiv}`}>
                                                                            <div className={`${styles.hoverDivImg2} ${styles.width100}`}>
                                                                                {/* <img loading="lazy" fetchPriority = "high" src={latestPostMap.iImg} className={`${styles.height250} ${styles.hoverImg} ${styles.imgMaxWidth}`} alt={latestPostMap?.desc?.length > 15 ? `${latestPostMap?.desc?.slice(0, 15)}...` : latestPostMap?.desc} /> */}

                                                                                <CategoryLazyLoadImage dataSrc={latestPostMap.iImg} className={`${styles.height250} ${styles.hoverImg} ${styles.imgMaxWidth}`} alt={latestPostMap?.desc?.length > 15 ? `${latestPostMap?.desc?.slice(0, 15)}...` : latestPostMap?.desc} />
                                                                            </div>
                                                                            <div className={styles.gridPostsTxt}>
                                                                                <h3 className={`${styles.gridPostTitle} ${styles.padding12} ${styles.fontSize18} ${styles.hoverFont} py-1`}>{latestPostMap.title.length > 25 ? `${latestPostMap.title.slice(0, 25)}...` : latestPostMap.title}</h3>
                                                                                <p className={styles.gridPostPara}>{latestPostMap.desc.length > 90 ? `${latestPostMap.desc.slice(0, 90)}...` : latestPostMap.desc}</p>
                                                                                <span className={`${styles.categoryHome} ${styles.catBg4} ${styles.gridPostsCate}`}>{latestPostMap.cName[0]}</span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            </Fragment>
                                                        )
                                                    }

                                                })
                                                : null
                                            : null
                                    }
                                </div>
                                <div className="col-md-12 mb-3">
                                    {/* <Link to={`/latest/category/${utm_source}/${allCateData ? allCateData.adSlots ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null}`} className={styles.loadMoreLink} target="_blank"><button className={styles.loadMore}> {lang == 2 ? process.env.REACT_APP_LOAD_MORE_HIN : process.env.REACT_APP_LOAD_MORE_ENG}</button></Link> */}
                                    <Link to={`/latest/category/${utm_source}/${allCateData ? allCateData.adSlots ? allCateData.adSlots.feedAd ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null : null}`} className={styles.loadMoreLink} target="_blank"><button className={styles.loadMore}> {lang == 2 ? process.env.REACT_APP_LOAD_MORE_HIN : process.env.REACT_APP_LOAD_MORE_ENG}</button></Link>
                                    {/* <a href={`/category/${allCateData ? footerAllCategoryData.catId : null}/${props.footerConfig.utm_source}/${allCateData ? allCateData.adSlots ? allCateData.adSlots.feedAd ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null : null}`}target='_blank'> {footerAllCategoryData.catName}</a> */}
                                </div>
                                {/* </Row> */}
                            </div>
                            <center>
                                <div id="latestAdsAdsLocation" className={styles.latestAdLoc}></div>
                            </center>
                        </section>
                        {/* First Category */}
                        <section className="mt-3">

                            <div className="container">
                                <div className="row">
                                    <div className={" mt-3 mb-3 col-md-12 " + styles.rowPadd}>
                                        <h2 className={styles.categoryTitle}>{allCateData ? allCateData.firstCategory.catName : null}</h2>
                                    </div>
                                    {
                                        allCateData ?
                                            allCateData.firstCategory?.list?.length >= 5 ?
                                                <>
                                                    <div className="col-md-12">

                                                        <Link to={`/categories/byte${allCateData.firstCategory.list[0].id}/${allCateData.firstCategory.list[0].slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">
                                                            <div className={`${styles.thirdCategory} ${styles.hoverDiv}`}>
                                                                <div className={styles.hoverDivImg3}>
                                                                    {/* <img loading="lazy" fetchPriority = "high" src={allCateData.firstCategory.list[0].iImg} className={`${styles.postBigImg} ${styles.height345} ${styles.hoverImg}`} alt={allCateData.firstCategory.list[0].desc.length > 15 ? `${allCateData.firstCategory.list[0].desc.slice(0, 15)}...` : allCateData.firstCategory.list[0].desc} /> */}
                                                                    <CategoryLazyLoadImage dataSrc={allCateData.firstCategory.list[0].iImg} className={`${styles.postBigImg} ${styles.height345} ${styles.hoverImg}`} alt={allCateData.firstCategory.list[0].desc.length > 15 ? `${allCateData.firstCategory.list[0].desc.slice(0, 15)}...` : allCateData.firstCategory.list[0].desc} />

                                                                </div>
                                                                <div className={styles.thirdCateTxt}>
                                                                    <h3 className={`${styles.gridPostTitle} ${styles.fontSize22} ${styles.padding12} ${styles.hoverFont} pt-3 pb-2`}>{allCateData.firstCategory.list[0].title.length > 25 ? `${allCateData.firstCategory.list[0].title.slice(0, 25)}...` : allCateData.firstCategory.list[0].title}</h3>
                                                                    <p className={styles.gridPostPara}>{allCateData.firstCategory.list[0].desc.length > 185 ? `${allCateData.firstCategory.list[0].desc.slice(0, 185)}...` : allCateData.firstCategory.list[0].desc}</p>
                                                                </div>
                                                            </div>
                                                        </Link>

                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            {
                                                                allCateData ?
                                                                    allCateData.firstCategory?.list?.length > 0 &&
                                                                    allCateData.firstCategory?.list?.map((firstCategoryData, firstCategoryIndex) => {
                                                                        if (firstCategoryIndex > 0 && firstCategoryIndex <= 4) {
                                                                            return (
                                                                                <Fragment key={firstCategoryIndex}>
                                                                                    <div className="col-md-6">
                                                                                        <Link to={`/categories/byte${firstCategoryData.id}/${firstCategoryData.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">

                                                                                            <div className={`${styles.thirdCategory} ${styles.hoverDiv} mb-4 `}>
                                                                                                <div className={styles.hoverDivImg3_3}>
                                                                                                    {/* <img loading="lazy" fetchPriority = "high" src={firstCategoryData.iImg} className={`${styles.postBigImg} ${styles.height150} ${styles.hoverImg}`} alt={firstCategoryData.desc.length > 15 ? `${firstCategoryData.desc.slice(0, 15)}...` : firstCategoryData.desc} /> */}
                                                                                                    <CategoryLazyLoadImage dataSrc={firstCategoryData.iImg} className={`${styles.postBigImg} ${styles.height150} ${styles.hoverImg}`} alt={firstCategoryData.desc.length > 15 ? `${firstCategoryData.desc.slice(0, 15)}...` : firstCategoryData.desc} />

                                                                                                </div>
                                                                                                <div className={styles.thirdCateTxt}>
                                                                                                    {/* <span className="categoryHome gridPostsCate catBg1">{contdata.name}</span> */}
                                                                                                    <h3 className={`${styles.gridPostTitle} ${styles.padding12} ${styles.fontSize18} ${styles.hoverFont}`}>{firstCategoryData.title.length > 25 ? `${firstCategoryData.title.slice(0, 25)}...` : firstCategoryData.title}</h3>
                                                                                                    <p className={styles.gridPostPara}>{firstCategoryData.desc.length > 56 ? `${firstCategoryData.desc.slice(0, 56)}...` : firstCategoryData.desc}</p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </Link>
                                                                                    </div>
                                                                                </Fragment>
                                                                            )

                                                                        }
                                                                    })
                                                                    : null
                                                            }


                                                        </div>

                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        {
                                                            allCateData ?
                                                                allCateData.firstCategory.list.length > 0 ?
                                                                    <Link to={`/category/${allCateData ? allCateData.firstCategory.catId : null}/${utm_source}/${allCateData ? allCateData.adSlots ? allCateData.adSlots.feedAd ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null : null}`} className={styles.loadMoreLink} target="_blank" ><button className={styles.loadMore}> {lang == 2 ? process.env.REACT_APP_LOAD_MORE_HIN : process.env.REACT_APP_LOAD_MORE_ENG}</button></Link>
                                                                    : "No Data"
                                                                : null
                                                        }
                                                    </div>
                                                </>
                                                : null
                                            : null
                                    }
                                </div>
                            </div>

                            {/* First Cat Ad Slot */}
                            <center>
                                <div id="0_articlefeedLocation"></div>
                            </center>
                        </section>
                        {/* Second Grid Category */}
                        <section className={styles.secondCateSect + "mt-3"}>
                            <div className="container">
                                <div className={styles.rowMargin + " row "}>
                                    <div className="col-md-12 mt-3 mb-3 px-3 py-lg-0 py-xl-0 py-xxl-0">
                                        <h2 className={styles.categoryTitle}>{allCateData ? allCateData.secondCategory.catName : null}</h2>
                                    </div>
                                    {
                                        allCateData ?
                                            allCateData.secondCategory?.list?.length >= 5 &&
                                            <>
                                                <div className={styles.cateRow + " col-md-12 "}>
                                                    <div className="row">
                                                        {
                                                            allCateData.secondCategory?.list?.map((secondCategoryData, secondCategoryIndex) => {
                                                                if (secondCategoryIndex >= 0 && secondCategoryIndex <= 1) {
                                                                    return (
                                                                        <Fragment key={secondCategoryIndex}>
                                                                            <div className="col-md-6">
                                                                                <Link to={`/categories/byte${secondCategoryData.id}/${secondCategoryData.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">

                                                                                    <div className={`${styles.fourthGridPosts} ${styles.hoverDiv}`}>
                                                                                        <div className={styles.hoverDivImg4}>
                                                                                            {/* <img loading="lazy" fetchPriority = "high" src={secondCategoryData.iImg} className={`${styles.postBigImg} ${styles.height300} ${styles.hoverImg}`} alt={secondCategoryData.desc.length > 15 ? `${secondCategoryData.desc.slice(0, 15)}...` : secondCategoryData.desc} /> */}
                                                                                            <CategoryLazyLoadImage dataSrc={secondCategoryData.iImg} className={`${styles.postBigImg} ${styles.height300} ${styles.hoverImg}`} alt={secondCategoryData.desc.length > 15 ? `${secondCategoryData.desc.slice(0, 15)}...` : secondCategoryData.desc} />

                                                                                        </div>
                                                                                        <div className={styles.fourthGridPostsTxt}>
                                                                                            <h3 className={`${styles.gridPostTitle} ${styles.fontSize18} ${styles.hoverFont} py-2`}>{secondCategoryData.title.length > 23 ? `${secondCategoryData.title.slice(0, 23)}...` : secondCategoryData.title}</h3>
                                                                                            <p className={styles.gridPostPara}>{secondCategoryData.desc.length > 65 ? `${secondCategoryData.desc.slice(0, 65)}...` : secondCategoryData.desc}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Link>
                                                                            </div>
                                                                        </Fragment>
                                                                    )

                                                                }

                                                            })
                                                        }

                                                    </div>
                                                </div>
                                                <div className="cateRow col-md-12">
                                                    {
                                                        allCateData ?
                                                            allCateData.secondCategory?.list?.length >= 5 ?
                                                                allCateData.secondCategory?.list?.map((secondCategoryData1, secondCategoryIndex1) => {
                                                                    if (secondCategoryIndex1 > 1 && secondCategoryIndex1 < 5) {
                                                                        return (
                                                                            <Fragment key={secondCategoryIndex1}>
                                                                                <Link to={`/categories/byte${secondCategoryData1.id}/${secondCategoryData1.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">

                                                                                    <div className={`${styles.fourthGridPostsRight} ${styles.hoverDiv}`} id={styles.secondRight}>
                                                                                        <div className={styles.fourthGridRightsTxt}>
                                                                                            <h3 className={`${styles.postTitleSmall} ${styles.fontSize16} ${styles.hoverFont}`}>{secondCategoryData1.title.length > 25 ? `${secondCategoryData1.title.slice(0, 25)}...` : secondCategoryData1.title}</h3>
                                                                                            <p className={styles.gridPostPara}>{secondCategoryData1.desc.length > 70 ? `${secondCategoryData1.desc.slice(0, 70)}...` : secondCategoryData1.desc}</p>

                                                                                        </div>
                                                                                        <div className={styles.hoverDivImg4_4}>
                                                                                            {/* <img loading="lazy" fetchPriority = "high" src={secondCategoryData1.iImg} className={styles.hoverImg} alt={secondCategoryData1.desc.length > 15 ? `${secondCategoryData1.desc.slice(0, 15)}...` : secondCategoryData1.desc} /> */}
                                                                                            <CategoryLazyLoadImage dataSrc={secondCategoryData1.iImg} className={styles.hoverImg} alt={secondCategoryData1.desc.length > 15 ? `${secondCategoryData1.desc.slice(0, 15)}...` : secondCategoryData1.desc} />

                                                                                        </div>
                                                                                    </div>
                                                                                </Link>
                                                                            </Fragment>

                                                                        )
                                                                    }

                                                                })
                                                                : null
                                                            : null
                                                    }

                                                </div>
                                                <div className="mb-3 col-md-12">
                                                    {
                                                        allCateData ?
                                                            allCateData.secondCategory.list.length > 0 ?
                                                                <Link to={`/category/${allCateData ? allCateData.secondCategory.catId : null}/${utm_source}/${allCateData ? allCateData.adSlots ? allCateData.adSlots.feedAd ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null : null}`} className={styles.loadMoreLink} target="_blank"><button className={styles.loadMore + " mt-2"}> {lang == 2 ? process.env.REACT_APP_LOAD_MORE_HIN : process.env.REACT_APP_LOAD_MORE_ENG}</button></Link>
                                                                : "No Data"
                                                            : null
                                                    }

                                                </div>
                                            </>
                                            : ""
                                    }
                                </div>
                            </div>
                            <center>
                                <div id="1_articlefeedLocation"></div>
                            </center>
                        </section>
                        {/* Third Grid Category */}
                        <section className={" mt-3 " + styles.thirdCateSect}>
                            <div className="container">
                                <div className="row">
                                    <div className={" col-md-12 mt-3 " + styles.rowPadd}>
                                        <h2 className={styles.categoryTitle}>{allCateData ? allCateData.thirdCategory.catName : null}</h2>
                                    </div>
                                    {allCateData ?
                                        allCateData.thirdCategory?.list?.length >= 5 ?

                                            <>
                                                <div className={`${styles.cateRow} ${styles.rowMargin}` + " row mb-3"}>
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            {

                                                                allCateData.thirdCategory?.list?.map((thirdCategoryData, thirdCategoryDataIndex) => {
                                                                    if (thirdCategoryDataIndex >= 0 && thirdCategoryDataIndex <= 1) {
                                                                        return (
                                                                            <Fragment key={thirdCategoryDataIndex}>
                                                                                <div className="col-md-6">
                                                                                    <Link to={`/categories/byte${thirdCategoryData.id}/${thirdCategoryData.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">

                                                                                        <div className={`${styles.gridPosts} ${styles.hoverDiv} mt-0`}>
                                                                                            <div className={styles.hoverDivImg5}>
                                                                                                {/* <img loading="lazy" fetchPriority = "high" src={thirdCategoryData.iImg} className={`${styles.height250} ${styles.hoverImg}`} alt={thirdCategoryData.desc.length > 15 ? `${thirdCategoryData.desc.slice(0, 15)}...` : thirdCategoryData.desc} /> */}
                                                                                                <CategoryLazyLoadImage dataSrc={thirdCategoryData.iImg} className={`${styles.height250} ${styles.hoverImg}`} alt={thirdCategoryData.desc.length > 15 ? `${thirdCategoryData.desc.slice(0, 15)}...` : thirdCategoryData.desc} />

                                                                                            </div>
                                                                                            <div className={styles.gridPostsTxt} style={{ padding: "10px 10px 15px" }}>
                                                                                                <h3 className={`${styles.gridPostTitle} ${styles.fontSize18} ${styles.hoverFont} py-2`}>{thirdCategoryData.title.length > 25 ? `${thirdCategoryData.title.slice(0, 25)}...` : thirdCategoryData.title}</h3>
                                                                                                <p className={styles.gridPostPara}>{thirdCategoryData.desc.length > 110 ? `${thirdCategoryData.desc.slice(0, 110)}...` : thirdCategoryData.desc}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Link>
                                                                                </div>
                                                                            </Fragment>
                                                                        )
                                                                    }
                                                                })

                                                            }

                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        {
                                                            allCateData ?
                                                                allCateData.thirdCategory?.list?.length > 4 ?
                                                                    allCateData.thirdCategory?.list?.map((thirdCategoryData1, thirdCategoryIndex1) => {
                                                                        if (thirdCategoryIndex1 > 1 && thirdCategoryIndex1 < 5) {
                                                                            return (
                                                                                <Fragment key={thirdCategoryIndex1}>
                                                                                    <Link to={`/categories/byte${thirdCategoryData1.id}/${thirdCategoryData1.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">

                                                                                        <div className={`${styles.fourthGridPostsRight} ${styles.hoverDiv}`}>
                                                                                            <div className={styles.hoverDivImg5_5}>
                                                                                                {/* <img loading="lazy" fetchPriority = "high" src={thirdCategoryData1.iImg} className={styles.hoverImg} alt={thirdCategoryData1.desc.length > 15 ? `${thirdCategoryData1.desc.slice(0, 15)}...` : thirdCategoryData1.desc} /> */}
                                                                                                <CategoryLazyLoadImage dataSrc={thirdCategoryData1.iImg} className={styles.hoverImg} alt={thirdCategoryData1.desc.length > 15 ? `${thirdCategoryData1.desc.slice(0, 15)}...` : thirdCategoryData1.desc} />

                                                                                            </div>
                                                                                            <div className={`${styles.fourthGridRightsTxt} ${styles.paddingLeft15}`}>
                                                                                                <h3 className={`${styles.postTitleSmall} ${styles.fontSize16} ${styles.hoverFont}`}>{thirdCategoryData1.title.length > 55 ? `${thirdCategoryData1.title.slice(0, 55)}...` : thirdCategoryData1.title}</h3>
                                                                                                <p className={styles.gridPostPara}>{thirdCategoryData1.desc.length > 70 ? `${thirdCategoryData1.desc.slice(0, 70)}...` : thirdCategoryData1.desc}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Link>
                                                                                </Fragment>
                                                                            )

                                                                        }
                                                                    })
                                                                    : null
                                                                : null
                                                        }

                                                    </div>

                                                </div>
                                                <div className="mb-3 col-md-12">
                                                    {
                                                        allCateData ?
                                                            allCateData.thirdCategory.list.length > 0 ?
                                                                <Link to={`/category/${allCateData ? allCateData.thirdCategory.catId : null}/${utm_source}/${allCateData ? allCateData.adSlots ? allCateData.adSlots.feedAd ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null : null}`} className={styles.loadMore} target="_blank"><button className={styles.loadMore + " mt-lg-0 mt-xl-0 mt-xxl-0"}> {lang == 2 ? process.env.REACT_APP_LOAD_MORE_HIN : process.env.REACT_APP_LOAD_MORE_ENG}</button></Link>
                                                                : "No Data"
                                                            : null
                                                    }
                                                </div>
                                            </>

                                            : '' : ''}
                                </div>
                            </div>
                            <center>
                                <div id="2_articlefeedLocation"></div>
                            </center>
                        </section>
                        {/* Fourth Grid Categry */}
                        <section className="mt-3 fourthCateSect">
                            <div className="container">
                                <div className={styles.rowMargin + " row "}>
                                    <div className="col-md-12 mt-3 mb-3">
                                        <h2 className={styles.categoryTitle}>{allCateData ? allCateData.fourthCategory.catName : null}</h2>
                                    </div>
                                    {
                                        allCateData ?
                                            allCateData.fourthCategory?.list?.length >= 6 ?
                                                allCateData.fourthCategory?.list.map((fourthCategorytData, fourthCategoryIndex) => {
                                                    if (fourthCategoryIndex >= 0 && fourthCategoryIndex < 6) {
                                                        return (
                                                            <Fragment key={fourthCategoryIndex}>
                                                                <div className={styles.cateRow + " col-md-6 "}>
                                                                    <Link to={`/categories/byte${fourthCategorytData.id}/${fourthCategorytData.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">

                                                                        <div id={styles.cateFourBord} className={`${styles.fourthGridPostsRight} ${styles.hoverDiv} ${styles.fourthGridCont}`}>
                                                                            <div className={styles.hoverDivImg6}>
                                                                                {/* <img loading="lazy" fetchPriority = "high" src={fourthCategorytData.iImg} className={`${styles.sixthPostsImg} ${styles.hoverImg}`} alt={fourthCategorytData.desc.length > 15 ? `${fourthCategorytData.desc.slice(0, 15)}...` : fourthCategorytData.desc} /> */}
                                                                                <CategoryLazyLoadImage dataSrc={fourthCategorytData.iImg} className={`${styles.sixthPostsImg} ${styles.hoverImg}`} alt={fourthCategorytData.desc.length > 15 ? `${fourthCategorytData.desc.slice(0, 15)}...` : fourthCategorytData.desc} />
                                                                            </div>
                                                                            <div className={styles.fourthGridRightsTxt}>
                                                                                <h3 className={`${styles.postTitleSmall} ${styles.fontSize17} ${styles.hoverFont}` + " pt-2 mb-0"}>{fourthCategorytData.title.length > 25 ? `${fourthCategorytData.title.slice(0, 25)}...` : fourthCategorytData.title}</h3>
                                                                                <p className={styles.gridPostPara + " mt-1 "}>{fourthCategorytData.desc.length > 90 ? `${fourthCategorytData.desc.slice(0, 90)}...` : fourthCategorytData.desc}</p>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            </Fragment>
                                                        )
                                                    }
                                                })
                                                : null
                                            : null
                                    }

                                    <div className="col-md-12 mb-3 mt-lg-0 mt-xl-0 mt-xxl-0">
                                        {
                                            allCateData ?
                                                allCateData.fourthCategory.list.length >= 6 ?
                                                    <Link to={`/category/${allCateData ? allCateData.fourthCategory.catId : null}/${utm_source}/${allCateData ? allCateData.adSlots ? allCateData.adSlots.feedAd ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null : null}`} className={styles.loadMoreLink + " mt-5"} target="_blank"><button className={styles.loadMore}> {lang == 2 ? process.env.REACT_APP_LOAD_MORE_HIN : process.env.REACT_APP_LOAD_MORE_ENG}</button></Link>
                                                    : ""
                                                : null
                                        }
                                    </div>

                                </div>

                            </div>
                            <center>
                                <div id="3_articlefeedLocation"></div>
                            </center>
                        </section>
                        {/* Fifth Grid Category */}
                        <section className={styles.fifthCateSect}>
                            <div className="Container">
                                <div className="row" style={{margin:"0"}}>
                                    <div className={" col-md-12 mt-3 mb-3 " + styles.rowPadd}>
                                        <h2 className={styles.categoryTitle}>{allCateData ? allCateData.fifthCategory.catName : null}</h2>
                                    </div>
                                </div>
                                <div className={`${styles.cateRow} ${styles.rowMargin}` + " row "} id="lastRowpadd">

                                    {
                                        allCateData ?
                                            allCateData.fifthCategory?.list?.length >= 6 ?
                                                allCateData.fifthCategory?.list?.map((fifthCateData, fifthCateDataIndex) => {
                                                    if (fifthCateDataIndex >= 0 && fifthCateDataIndex < 8) {
                                                        return (
                                                            <Fragment key={fifthCateDataIndex}>

                                                                <div className="mb-3 col-md-6">
                                                                    <Link to={`/categories/byte${fifthCateData.id}/${fifthCateData.slug}&utm_source=${utm_source}&utm_medium=Mobile&utm_campaign=January&article_type=${article_type}`} target="_blank">
                                                                        <div className={styles.sixthCateDiv}>

                                                                            <div className={`${styles.fourthGridPostsRight} ${styles.hoverDiv} ${styles.lastCateDiv} mb-0 pb-0 `} id={styles.sixGridTxt}>
                                                                                <div className={`${styles.hoverDivImg5_5} ${styles.imgWidth6} ${styles.lastCateImg}`}>
                                                                                    {/* <img loading="lazy" fetchPriority = "high" src={fifthCateData?.iImg} className={styles.hoverImg} alt={fifthCateData.desc.length > 15 ? `${fifthCateData.desc.slice(0, 15)}...` : fifthCateData.desc} /> */}
                                                                                    <CategoryLazyLoadImage dataSrc={fifthCateData?.iImg} className={styles.hoverImg} alt={fifthCateData.desc.length > 15 ? `${fifthCateData.desc.slice(0, 15)}...` : fifthCateData.desc} />
                                                                                </div>
                                                                                <div className={`${styles.sixGridRightsTxt}`}>
                                                                                    <h3 className={`${styles.postTitleSmall} ${styles.fontSize16} ${styles.hoverFont}` + " mt-2 "}>{fifthCateData.title.length > 20 ? `${fifthCateData.title.slice(0, 20)}...` : fifthCateData.title}</h3>
                                                                                    <p className={styles.gridPostPara + " mt-2 mx-0"}>{fifthCateData.desc.length > 50 ? `${fifthCateData.desc.slice(0, 50)}...` : fifthCateData.desc}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </Link>
                                                                </div>
                                                            </Fragment>
                                                        )
                                                    }

                                                }) : null
                                            : null

                                    }


                                    <div className="col-md-12 mb-3">
                                        {
                                            allCateData ?
                                                allCateData.fifthCategory.list.length >= 6 ?
                                                    <Link to={`/category/${allCateData ? allCateData.fifthCategory.catId : null}/${utm_source}/${allCateData ? allCateData.adSlots ? allCateData.adSlots.feedAd ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null : null}`} className={styles.loadMoreLink} target="_blank"><button className={styles.loadMore + " mt-1 "}> {lang == 2 ? process.env.REACT_APP_LOAD_MORE_HIN : process.env.REACT_APP_LOAD_MORE_ENG}</button></Link>
                                                    : ""
                                                : null
                                        }
                                    </div>

                                </div>
                            </div>
                            <center>
                                <div id="4_articlefeedLocation"></div>
                            </center>
                        </section>
                    </>
                    : null
            }
            <div id="stickyAds" className={styles.stickyAdsHome}></div>
            {showFooter && (


                <Footer allCateData={allCateData} footerConfig={{
                    utm_source: utm_source,
                    article_type: article_type
                }} />

            )}

        </div>
    )
});

export default HomeMain;